import React, { createContext, useContext, useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const AuthContext = createContext({
  currentUser: null,
  userProfile: null,
  loading: true,
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      try {
        if (user) {
          setCurrentUser(user);
          const userDocRef = doc(db, 'users', user.uid);
          const snap = await getDoc(userDocRef);
          if (snap.exists()) {
            const data = snap.data();
            const isAdmin = !!data.isAdmin || data.role === 'admin';
            setUserProfile({ ...data, uid: user.uid, email: user.email, isAdmin });
          } else {
            setUserProfile({ uid: user.uid, email: user.email, isAdmin: false });
          }
        } else {
          setCurrentUser(null);
          setUserProfile(null);
        }
      } finally {
        setLoading(false);
      }
    });
    return () => {
      if (typeof unsubscribe === 'function') {
        unsubscribe();
      }
    };
  }, []);

  const value = { currentUser, userProfile, loading };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
